var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('OmtLayoutContainer',[(!!_vm.getStep)?_c('OmtRow',{attrs:{"mb":"24px"}},[_c('OmtStepper',{attrs:{"currentStep":_vm.getStep,"totalSteps":3}})],1):_vm._e(),_c('OmtRow',[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }